import React from 'react'

import Slide from '@material-ui/core/Slide'

const slideUp = props => <Slide direction="up" {...props} />;

export default slideUp ;


// WEBPACK FOOTER //
// ./src/app/transitions/slideUp.js